import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { TaxPayerStatusName } from 'src/app/entities/util';
import { SharedService } from 'src/app/services/sharedService';
import { TasDataSource } from 'src/app/services/tasGovTable.datasource';
import { TaxPayerService } from 'src/app/services/taxPayer.service';
import { UserService } from 'src/app/services/user.service';
import { TaxPayerDialogComponent } from '../dialogs/tax-payer-dialog/tax-payer-dialog.component';
import { CompanyDexieService } from 'src/app/services/companyDexie-services/companyDexie.service';
import { TaxNameService } from 'src/app/services/taxName.service';
import { CategoryService } from 'src/app/services/category.service';

@Component({
  selector: 'app-tax-payer-match-requests',
  templateUrl: './tax-payer-match-requests.component.html',
  styleUrls: ['./tax-payer-match-requests.component.css']
})
export class TaxPayerMatchRequestsComponent implements OnInit {

  @Input() dec_key;
  @Input() dec_year;
  @Input() status;

  subscriptionAddTaxpayer: any;
  subscriptionUpdateUser: any;
  subscriptionDeactivateUser: any;
  subscriptionActivateUser: any;

  displayedColumns: string[] = ['username', 'date', 'name', 'municipality', 'status'];
  dataSource: TasDataSource;
  statusNames = TaxPayerStatusName
  filterObject: {};
  user: any;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  taxPayersEndpoint = 'company-representative/matchrequests';
  municipalityChangeSubscription: any
  loading = { inProgress: false, downloadInProgress: false }
  constructor(private taxPayerService: TaxPayerService, public dialog: MatDialog,
    public taxNameService: TaxNameService,
    public sharedService: SharedService, public router: Router,
    public userService: UserService, public translate: TranslateService,
    public companyDexieService: CompanyDexieService,
    public categoryService: CategoryService,
    public route: ActivatedRoute) {
  }

  ngOnInit() {
    this.dataSource = new TasDataSource(this.taxPayerService, this.companyDexieService)

    this.municipalityChangeSubscription = this.sharedService.changeMunicipalityEmitter.subscribe(val => {
      if (!this.filterObject) {
        this.filterObject = {}
      }
      this.reset()
      if (localStorage.getItem('municipality')) {
        if (localStorage.getItem('municipality') == "-1") {
          delete this.filterObject['municipality']
        } else {
          this.filterObject['municipality'] = [localStorage.getItem('municipality')]
        }
      } else {
        delete this.filterObject['municipality']
      }
      this.loadTaxPayerData()
    })
    this.userService.getCurrentUser().subscribe(user => {
      this.user = user
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;

      this.subscriptionAddTaxpayer = this.sharedService.addTaxPayerEmmitter.subscribe(val => {
        this.loadTaxPayerData();
      })
      this.subscriptionDeactivateUser = this.sharedService.deactivateUserEmmitter.subscribe(val => {
        if (val) {
          this.taxPayerService.deactivateResource(this.taxPayersEndpoint, val).subscribe(res => {
            this.loadTaxPayerData();
          })
        }
      })

      this.subscriptionActivateUser = this.sharedService.activateUserEmmitter.subscribe(val => {
        if (val) {
          this.taxPayerService.updateResource('company-representative/matchrequests', val).subscribe(res => {
            this.loadTaxPayerData();
          })
        }
      })
    })
  }

  canAddTaxpayer() {
    if (this.user) {
      return !['MAYOR_TREASURER', 'CENTRAL_READER', 'SECRETARY_ASSISTANT'].includes(this.user.role)
    }

    return false
  }

  objectComparisonFunctionId = function (option, value): boolean {
    let sss = value ? option.key === value.key : false
    return sss;
  };

  filter: any;
  ngAfterViewInit() {

    setTimeout(() => {
      if (this.dec_key && this.dec_year && this.status) {
        this.filterObject['key'] = this.dec_key
        this.filterObject['year'] = this.dec_year
        this.filterObject['status'] = this.status
      }
      if (!this.filterObject) {
        this.filterObject = {}
      }

    }, 0)

    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);


    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        tap(() => this.loadTaxPayerData())
      )
      .subscribe();

  }

  loadTaxPayerData() {
    this.dataSource.emptyData()
    this.loading.inProgress = true
    this.dataSource.loadData('company-representative/matchrequests',
      '',
      this.sort.direction,
      this.sort.active,
      this.paginator.pageIndex,
      this.paginator.pageSize, this.filterObject, this.loading);
  }

  openTaxPayerDialog(taxPayer): void {
    const dialogRef = this.dialog.open(TaxPayerDialogComponent, {
      width: '800px', panelClass: 'custom-dialog-container',
      data: taxPayer
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  goToMatchRequest(row) {
        this.router.navigate(['match_request/'+row.id]);
  }

  ngOnDestroy() {
    if (this.subscriptionUpdateUser) this.subscriptionUpdateUser.unsubscribe();
    if (this.subscriptionDeactivateUser) this.subscriptionDeactivateUser.unsubscribe();
    if (this.subscriptionActivateUser) this.subscriptionActivateUser.unsubscribe();
    if (this.municipalityChangeSubscription) this.municipalityChangeSubscription.unsubscribe()
  }

  isObject(value) {
    return value && typeof value === 'object' && value.constructor === Object;
  }


  shouldDisplayValue(value) {
    return value !== 0;
  }

  objectFilter = {};

  advancedSearch(filter) {
    this.loading['error'] = false
    if (!this.filterObject) {
      this.filterObject = {}
    }
    let advF = [
      'municipality',
      'name',
      'telephone',
      'status'
    ];
    advF.forEach((elem) => {
      if (!filter[elem] || filter[elem].length === 0) delete this.filterObject[elem];
    });
    this.filterObject = Object.assign({}, this.filterObject, filter);
    this.dataSource.emptyData()
    this.loading.inProgress = true
    this.dataSource.loadData(
      "company-representative/matchrequests",
      '',
      this.sort.direction,
      this.sort.active,
      this.paginator.pageIndex,
      this.paginator.pageSize,
      this.filterObject,
      this.loading
    );
  }
  reset() {
    this.filterObject = {};
  }
}
